import { createUseStyles } from "react-jss";
import { mediaQueries } from "../../constants/mediaQueries";

export const ButtonStyle = createUseStyles((theme: any) => ({
    withInverse: {
        background: "transparent",
        color: "var(--text-color-purple)",
        border: "1px solid",
    },
    container: {
        display: "flex",
        justifyContent: "center",
        width: "95vw",
        maxWidth: 500,
        "ion-button": {
            width: "100%",
        },
    },
}));
